<ion-header
    mode="ios"
    class="{{ (platform$ | async) === 'ios' ? 'header-wrap-ios' : 'header-wrap' }}"
>
    <ion-searchbar
        *ngIf="hasSearch && !(isSeachBarHidden$ | async)"
        #searchbar
        clearIcon="close"
        [value]="query$ | async"
        show-clear-button="always"
        [placeholder]="
            entityType === 'projects'
                ? ('LIST_PROJECTS.SEARCH' | translate)
                : ('OFFERS.SEARCH_OFFERS' | translate)
        "
        [debounce]="700"
        (ionInput)="onSearchHandler($event)"
    >
    </ion-searchbar>
    <ion-icon
        name="close"
        *ngIf="hasSearch && !(isSeachBarHidden$ | async)"
        (click)="toggleSearchBar()"
    ></ion-icon>
    <app-back-arrow
        *ngIf="backArrow"
        [url]="backUrl"
        (click)="backButtonClickHandler()"
    ></app-back-arrow>
    <ion-title *ngIf="(isSeachBarHidden$ | async) || !hasSearch" mode="md">
        {{ title }}
    </ion-title>
    <ion-icon
        *ngIf="hasSearch && (isSeachBarHidden$ | async)"
        name="search"
        (click)="toggleSearchBar()"
    ></ion-icon>
    <ng-container
        *ngIf="optionsTemplate && (isSeachBarHidden$ | async)"
        [ngTemplateOutlet]="optionsTemplate"
    >
    </ng-container>
</ion-header>

<ion-header
    *ngIf="(checkOutTimer || checkedAt) && showCheckinBar"
    (click)="checkOut()"
    class="clocking-wrapper"
>
    <ion-icon name="time-outline"></ion-icon>
    <div class="clocking-info-wrap">
        <span class="clocking-info">{{ "SHARED.CHECKED_IN_ON" | translate }}</span>
        <span class="clocking-project">
            {{ checkinProject?.project_number ? "#" + checkinProject?.project_number : "" }}
            {{ checkinProject?.name | projectDescription: 20 }}
        </span>
    </div>
    <ng-template [ngIf]="checkOutTimer" [ngIfElse]="checkInFuture">
        <div class="clocking-time">
            {{ checkOutTimer }}
        </div>
    </ng-template>
    <ng-template #checkInFuture>
        <div class="txt-right clocking-future">
            <div>
                {{ "PROJECT_DETAILS.CHECKED_AT_HEADER" | translate }}
            </div>
            <div>
                {{ checkedAt }}
            </div>
        </div>
    </ng-template>
</ion-header>
